export default "__VITE_ASSET__5cf7173c__"